import { render, staticRenderFns } from "./SelectedVehicle.vue?vue&type=template&id=284ed2e8"
import script from "./SelectedVehicle.vue?vue&type=script&lang=js"
export * from "./SelectedVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports